import React, { useContext, useEffect } from "react";
import { AppContext } from "../../contexts/AppContext";
import MediaTable from "../../components/Tables/MediaTable";

export const DataItems = ({ show = false }) => {
  const { media, fetchMedia } = useContext(AppContext);

  useEffect(() => {
    if (!media || media.length === 0) {
      fetchMedia();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  if (!media) {
    return null;
  }

  return (
    <div style={{ width: "100%", display: show ? "flex" : "none" }}>
      <MediaTable media={media} />
    </div >
  );
};

export default DataItems;
